import { render, staticRenderFns } from "./CommonCard.vue?vue&type=template&id=d04d83d4&scoped=true&"
import script from "./CommonCard.vue?vue&type=script&lang=ts&"
export * from "./CommonCard.vue?vue&type=script&lang=ts&"
import style0 from "./CommonCard.vue?vue&type=style&index=0&id=d04d83d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04d83d4",
  null
  
)

export default component.exports